// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  productReviews: {
    name: 'product-reviews',
    componentName: 'ProductReviewsContainer',
    chunk: () => import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "product-reviews" */
      './pages/ProductReviewsContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ProductReviewsContainer.js')).ProductReviewsContainer
        : currentRouteName === 'product-reviews'
          ? currentRouteComponent
          : generateAsyncRoute(
            () => this.chunk().then((pageModule) => ({ default: pageModule.ProductReviewsContainer })))
    },
    path: '/:context?/p/reviews/:slug?/:itemId/:page?',
    channel: null,
    varnish: true
  },

  questions: {
    name: 'questions',
    componentName: 'ProductQandAContainer',
    chunk: () => import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "questions" */
      './pages/ProductQandAContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ProductQandAContainer.js')).ProductQandAContainer
        : currentRouteName === 'questions'
          ? currentRouteComponent
          : generateAsyncRoute(
            () => this.chunk().then((pageModule) => ({ default: pageModule.ProductQandAContainer })))
    },
    path: '/:context?/p/questions/:slug?/:itemId/:page?',
    channel: null,
    varnish: true
  },

  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "home" */
      './pages/Home'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })))
    },
    path: '/:context?/',
    channel: null,
    varnish: true
  },

  thankYou: {
    name: 'thank-you',
    componentName: 'ThankYouContainer',
    chunk: () => import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "thank-you" */
      './pages/ThankYouContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ThankYouContainer.js')).ThankYouContainer
        : currentRouteName === 'thank-you'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ThankYouContainer })))
    },
    path: '/:context?/l/reviews/confirmation',
    channel: null,
    varnish: true
  },
});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
}
